import React from 'react';
import { Button, Container, Modal } from '@mantine/core';
import { NextLink } from '@mantine/next';
import { AppRoutes } from '@core/router/AppRoutes';
import useIsMounted from '@hooks/use-is-mounted';
import useDxbTheme from '@hooks/use-dxb-theme';
import useStyles from './BookingSuccessModal.styles';


interface Props {
    open: boolean;
    onClose: () => void;
}

export const BookingSuccessModal: React.FC<Props> = ({
                                                         open,
                                                         onClose
                                                     }) => {

    const { classes } = useStyles();
    const isMounted = useIsMounted();
    const { isDark, theme } = useDxbTheme();

    return isMounted && (
        <Container>
            <Modal
                className={classes.modalWrapper}
                overlayColor={isDark ? theme.colors.dark[9] : theme.colors.gray[2]}
                overlayOpacity={0.55}
                overlayBlur={3}
                centered={true}
                withCloseButton={true}
                closeOnClickOutside={false}
                closeOnEscape={false}
                title="Your booking was successful!"
                onClose={() => {
                    onClose();
                }}
                opened={open}
            >

            <Button
                className={classes.modalButtons}
                component={NextLink}
                title="Booking Details"
                href={AppRoutes.BOOKINGS}
                variant="filled"
                radius="xs"
                mt="xl"
                fullWidth={true}
                onClick={() => onClose()}
            >
                Booking details
            </Button>

            </Modal>
        </Container>
    )

}
